<template>
    <el-container>
      <!--
      <el-aside>
        <el-menu :default-active="dactive" class="el-menu-vertical-demo" @select="menuselect" @open="handleOpen" @close="handleClose" :collapse="isCollapse">
          <el-menu-item index="1">
            <i class="el-icon-menu"></i>
            <span slot="title">基本信息</span>
          </el-menu-item>
          <el-menu-item index="2">
            <i class="el-icon-menu"></i>
            <span slot="title">企业信息</span>
          </el-menu-item>
          <el-menu-item index="3">
            <i class="el-icon-menu"></i>
            <span slot="title">功能选择</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      -->
      <el-container style="display: flex;align-items: center;justify-content: center;">
        <el-header class="formdiv">
          <el-steps :active="activestep" finish-status="success" simple style="margin-top: 20px">
            <el-step title="手机验证" icon="el-icon-edit"></el-step>
            <el-step title="设置密码" icon="el-icon-edit"></el-step>
          </el-steps>
        </el-header>
        <el-main class="formdiv">
          <ValidPhoneEx :hidden="ro_one" @regtwo="regtwo"></ValidPhoneEx>
          <SaveAccount :hidden="ro_two"></SaveAccount>
        </el-main>
      </el-container>
    </el-container>
</template>

<script>
  import ValidPhoneEx from './ValidPhoneEx'
  import SaveAccount from './SaveAccount'
  var that
  export default {
    name: 'RegCus',
    components: {
      ValidPhoneEx,
      SaveAccount
    },
    data () {
      return {
        activestep: 1,
        dactive: 1,
        ro_one: false,
        ro_two: true
      }
    },
    mounted () {
      document.title = '账号注册'
      that = this
      window.console.log(that)
      that.activestep = parseInt(localStorage.getItem('regstep'))
      if (that.activestep === '' || that.activestep === 0 || localStorage.getItem('regstep') === null) {
        that.activestep = 1
      }
      switch (that.activestep) {
        case 1:
          that.ro_one = false
          that.ro_two = true
          break;
        case 2:
          that.ro_one = true
          that.ro_two = false
          break;
      }
    },
    methods:{
      regtwo () {
        that.ro_one = true
        that.ro_two = false
        that.activestep = 2
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/regedit/RegCus.vue